import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { invitationsActions } from 'features/invitations';

const useInvitations = () => {
  const dispatch = useDispatch();
  const getInvitations = useCallback(({ offset, query }) => dispatch(invitationsActions.getInvitations({ offset, query })), [dispatch]);
  const createInvitation = useCallback((invitation) => dispatch(invitationsActions.createInvitation(invitation)), [dispatch]);
  const deleteInvitation = useCallback(id => dispatch(invitationsActions.deleteInvitation(id)), [dispatch]);
  const clearLocalInvitations = useCallback(() => dispatch(invitationsActions.clearLocalInvitations()), [dispatch]);

  return {
    getInvitations,
    createInvitation,
    deleteInvitation,
    clearLocalInvitations
  };
};

export default useInvitations;